<template>
  <div>
    <div v-if="showSetData">
      <div class="section waiver-header waiver-success" :style="{ background : success && (data.bg_color ? data.bg_color : '#f5d784')}">
        <div class="container">
          <img class="icon" src="../../assets/header/icon.jpg" />
        </div>
        <div class="success-title">Thank you for signing!</div>
        <div class="success-tips">
          Show this page to our staff for checking in
        </div>
        <!-- <div class="success-refresh-btn">Refresh Page</div> -->
        <button
          type="submit"
          id="submitButton"
          class="button is-primary is-rounded is-fullwidth has-text-weight-medium"
          :style="{ backgroundColor : config.button_bgcolor}"
          @click="refresh"
        >
          Refresh Page
        </button>
      </div>
      <div class="show-contaniner">
        <div>
          <h5 class="title is-5 title-name-1">
            <span class="icon mr-2"
              ><img src="@/assets/img/id.svg" alt="-"
            /></span>
            Parent / Guardian Information
          </h5>
          <div class="content-1">
            <div>
              <span>Name：</span>
              {{ waiverData.first_name }},
              {{ waiverData.last_name }}
            </div>
            <div>
              <span>Gender：</span>
              {{ gender[waiverData.gender] }}
            </div>
            <div>
              <span>Date of Birth：</span>
              {{ waiverData.birth_date }}
            </div>
            <div>
              <span>Email：</span>
              {{ waiverData.email }}
            </div>
            <div>
              <span>Phone：</span>
              {{ waiverData.phone_umber }}
            </div>
            <div>
              <span>Address：</span>
              {{ waiverData.address_line1 }} {{ waiverData.address_line2 }}
              {{ waiverData.city }}
            </div>
            <div>
              <span>Emergency Contact：</span>
              {{ waiverData.emergency_contact }}
            </div>
          </div>
        </div>
      </div>
      <div class="show-contaniner">
        <div>
          <h5 class="title is-5 title-name-1">
            <span class="icon mr-2"
              ><img src="@/assets/img/friends.svg" alt="-"
            /></span>
            Participants Information
          </h5>
          <div class="content-1">
            <div>
              <span>Do Adults Participant In?：</span>
              {{ waiverData.is_signer_play == 1 ? "Yes" : "No" }}
            </div>
            <div>
              <div><span>Participants：</span></div>
              <div
                v-for="(item, index) in waiverData.participants_info"
                :key="index"
              >
                {{ item.first_name }}, {{ item.last_name }} /
                {{ gender[item.gender] }} / {{ gender[item.birth_date] }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="show-contaniner title-name-1 is_checked_name">
        <div class="columns" v-if="waiverData.protocol.indexOf(2) > -1">
          <div class="column">
            <div>
              <label
                for="mailList"
                class="checkbox has-text-weight-medium has-text-dark"
              >
                <input
                  disabled
                  v-model="checked"
                  type="checkbox"
                  id="mailList"
                  name="mailList"
                  formcontrolname="mailList"
                  class="mr-2 ng-untouched ng-pristine ng-valid"
                />
                I'd like to receive special offers or special activities through
                emails / text messages from KidsTopia.
              </label>
            </div>
          </div>
        </div>
        <div class="columns" v-if="waiverData.protocol.indexOf(3) > -1">
          <div class="column">
            <div class="form-group">
              <label
                for="confirmInfoCorrect"
                class="checkbox has-text-weight-medium has-text-dark"
              >
                <input
                  disabled
                  v-model="checked"
                  type="checkbox"
                  id="confirmInfoCorrect"
                  name="confirmInfoCorrect"
                  formcontrolname="confirmInfoCorrect"
                  class="mr-2 ng-untouched ng-pristine ng-invalid"
                />
                I certify that I am the parent or legal guardian of the above
                minors and confirm that the information I entered is complete,
                accurate and true.
              </label>
            </div>
          </div>
        </div>
        <div
          class="columns justify-content-center justify-content-sm-start"
          v-if="waiverData.protocol.indexOf(4) > -1"
        >
          <div class="column is-12">
            <div class="form-group">
              <label
                for="confirmAgreeTerms"
                class="checkbox has-text-weight-medium has-text-dark"
              >
                <input
                  disabled
                  v-model="checked"
                  type="checkbox"
                  id="confirmAgreeTerms"
                  name="confirmAgreeTerms"
                  formcontrolname="confirmAgreeTerms"
                  class="mr-2 ng-untouched ng-pristine ng-invalid"
                />
                I confirm I carefully read and agree to the terms of the above
                agreement. I understand that electronically certifying this
                waiver document just as if I would physically sign it if it was
                on paper.
              </label>
            </div>
          </div>
        </div>
      </div>
      <div class="show-contaniner" v-if="waiverData.signature_info">
        <img
          width="300"
          height="150"
          alt="Confirmed Signature"
          :src="waiverData.signature_info"
        />
      </div>
      <div class="show-contaniner">
        <strong>Date</strong>: {{ getCurrentDateString() }}
      </div>
    </div>
    <div v-else>
      <div class="section waiver-header" :style="{ background : success && (data.bg_color ? data.bg_color : '#f5d784')}">
        <div class="container">
          <div class="columns header is-vcentered is-hidden-mobile">
            <div class="column">
              <h1 class="title is-1 is-spaced">{{ data.title }}</h1>
              <p class="subtitle has-text-weight-medium">
                {{ data.desc }}
              </p>
            </div>
            <div class="column">
              <template v-if="data && data.video_url">
                <div class="image is-16by9">
                  <div class="iframe-wrap" v-html="data.video_url"></div>
                </div>
              </template>
              <template v-else-if="data.image">
                <div class="image">
                  <img alt="..." :src="data.image" />
                </div>
              </template>
            </div>
          </div>
          <div class="columns header is-hidden-tablet">
            <div class="column">
              <h1 class="title is-1 is-spaced">Waiver</h1>
              <p class="subtitle has-text-weight-medium">
                {{ data.desc }}
              </p>
            </div>
          </div>
        </div>
      </div>
      <parent-waiver v-if="config.shop_type == 1" :data="data" />
      <son-waiver
        v-if="config.shop_type == 0"
        :data="data"
        @getData="getSonWaiverData"
      />
    </div>
  </div>
</template>
<script>
import { wavierInfo } from "@/server/api.js";
import store from "@/store";
import ParentWaiver from "./components/ParentWaiver.vue";
import SonWaiver from "./components/SonWaiver.vue";

export default {
  components: {
    ParentWaiver,
    SonWaiver,
  },
  computed: {
    config() {
      return store.state.global.configList || {};
    },
  },
  data() {
    return {
      data: {},
      gender: {
        0: "Female",
        1: "Male",
        2: "Not Specified",
      },
      showSetData: false,
      // waiverData: null,
      waiverData: {
        // address_linel: "1",
        // address_line2: "1",
        // birth_date: "2024-05-13",
        // city: "1",
        // email: "11@gq.comm",
        // emergency_contact: "(111)111-1111",
        // first_name: "first name",
        // gender: "0",
        // is_signer_play: "1",
        // last_name: "last name",
        // participants_info: [
        //   {
        //     first_name: 1,
        //     last_name: 1,
        //     gender: 1,
        //     birth_date: "2020-12-23",
        //   },
        // ],
        // signature_info: "data:image/png;base64,iVBORWOKGgOAAAANSUhEUgAAA",
        // state_id: 3,
        // zip: "1",
        // protocol:"[3,4]"
      },
      checked: true,
      success: false
    };
  },
  created() {
    this.getInfo();
  },
  methods: {
    getCurrentDateString() {
      const options = { year: "numeric", month: "long", day: "numeric" };
      const now = new Date();
      return now.toLocaleDateString("en-US", options);
    },
    async getInfo() {
      try {
        const { status, data } = await wavierInfo({});
        if (status == 0) {
          this.data = data;
          this.success = true;
          setTimeout(() => {
            var iframe = document.getElementsByTagName("iframe");
            for (let i = 0; i <= iframe.length - 1; i++) {
              iframe[i].style.width = "100%";
              iframe[i].style.height = "100%";
            }
          }, 0);
        }
      } catch (error) {}
    },
    getSonWaiverData(data) {
      this.showSetData = true;
      if (data.participants_info) {
        data.participants_info = JSON.parse(data.participants_info);
      }
      if (data.protocol) {
        data.protocol = JSON.parse(data.protocol);
      }
      this.waiverData = data;
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      })

      setTimeout(()=> {
        location.reload();
      }, 1000 * 60)
    },
    refresh() {
      this.showSetData = false;
      location.reload();
    }
  },
};
</script>
<style scoped>
.waiver-header {
  margin: 0 auto;
  margin-top: 50px;
}
.columns {
  margin: auto;
  margin-left: -1.5rem;
  margin-right: -1.5rem;
  margin-top: -1.5rem;
}
@media screen and (min-width: 1024px) {
  .container {
    max-width: 960px;
  }
}
@media screen and (min-width: 1408px) {
  .container {
    max-width: 1344px;
  }
}
@media screen and (min-width: 769px) {
  .columns:not(.is-desktop) {
    display: flex;
  }
}
.columns.is-vcentered {
  align-items: center;
}
.columns:not(:last-child) {
  margin-bottom: 0rem;
}
.column {
  display: block;
  flex-basis: 0;
  flex-grow: 1;
  flex-shrink: 1;
  padding: 1.5rem;
}
.title.is-1 {
  font-size: 3rem;
}
.tabs:not(:last-child),
.pagination:not(:last-child),
.message:not(:last-child),
.level:not(:last-child),
.breadcrumb:not(:last-child),
.block:not(:last-child),
.title:not(:last-child),
.subtitle:not(:last-child),
.table-container:not(:last-child),
.table:not(:last-child),
.progress:not(:last-child),
.notification:not(:last-child),
.content:not(:last-child),
.box:not(:last-child) {
  margin-bottom: 1.5rem;
}

.title {
  color: #363636;
  font-family: Rubik, sans-serif;
  font-size: 2rem;
  font-weight: 600;
  line-height: 1.125;
}
.title,
.subtitle {
  word-break: break-word;
}
.has-text-weight-medium {
  font-weight: 500 !important;
}
.image {
  display: block;
  position: relative;
  height: 340px;
}
.image img {
  display: block;
  height: 100%;
}
.columns:last-child {
  margin-bottom: -1.5rem;
}
@media screen and (max-width: 768px) {
  .is-hidden-mobile {
    display: none !important;
  }
}
@media screen and (min-width: 769px) {
  .is-hidden-tablet {
    display: none !important;
  }
  .columns:not(.is-desktop) {
    display: flex;
  }
}
.section {
  padding: 3rem 1.5rem;
}
@media screen and (min-width: 1024px) {
  .section {
    padding: 3rem;
  }
}

.has-text-centered {
  text-align: center !important;
}

.py-5 {
  padding-top: 1.5rem !important;
  padding-bottom: 1.5rem !important;
}
.tag:not(body).is-rounded {
  border-radius: 9999px;
}
.tag:not(body).is-large {
  font-size: 1.25rem;
}
.tag:not(body).is-primary {
  background-color: #de4c50;
  color: #fff;
}
.tag:not(body) {
  align-items: center;
  background-color: #f5f5f5;
  border-radius: 4px;
  color: #757763;
  display: inline-flex;
  font-size: 0.75rem;
  height: 2em;
  justify-content: center;
  line-height: 1.5;
  padding-left: 0.75em;
  padding-right: 0.75em;
  white-space: nowrap;
}
.has-text-weight-semibold {
  font-weight: 600 !important;
}
.mr-2 {
  margin-right: 0.5rem !important;
}
.has-text-white {
  color: #fff !important;
}
.fas,
.fa-solid {
  font-weight: 900;
}
.mt-5 {
  margin-top: 1.5rem !important;
}
.subtitle {
  color: #757763;
  font-family: Quicksand, sans-serif;
  font-size: 1.25rem;
  font-weight: 400;
  line-height: 1.25;
}
.is-4 {
  font-size: 1.5rem;
}
.iframe-wrap {
  bottom: 0;
  left: 0;
  position: absolute;
  right: 0;
  top: 0;
}
.waiver-success {
  background: #f0f3fb;
  text-align: center;
}
.waiver-success img {
  width: 100px;
  height: auto;
}
.success-title {
  color: black;
  font-size: 2.2rem;
  font-weight: bold;
  margin-top: 10px;
}
.success-tips {
  font-size: 1.4rem;
  margin-top: 10px;
}
.button.is-primary {
  background-color: #de4c50;
  border-color: transparent;
  -webkit-box-shadow: none;
  box-shadow: none;
  color: white;
  border-radius: 20px;
  padding: 10px 20px;
  margin-top: 20px;
}
.show-contaniner {
  width: 40%;
  margin: auto;
}
@media screen and (max-width: 769px) {
  .show-contaniner {
    width: 90%;
    margin: auto;
  }
}
.icon {
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  display: -webkit-inline-box;
  display: -ms-inline-flexbox;
  display: inline-flex;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  height: 1.5rem;
  width: 1.5rem;
}
.icon img {
  height: auto;
  max-width: 100%;
}
.is-5 {
  font-size: 1.25rem;
}
.title-name-1 {
  margin-top: 40px;
}
.content-1 span {
  color: black;
  font-weight: 500;
}
.is_checked_name {
  color: black;
}
#submitButton {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/pages/policy/waiver.vue